import React, { useState, useEffect } from 'react';
import rosaryData from '../data/rosary.json';
import './Amen.css';

const Amen = ({ onComplete, sessionStartTime }) => {
  const [timeRemaining, setTimeRemaining] = useState(60); // 1 minute

  useEffect(() => {
    // Calculate remaining time based on session start
    const calculateRemainingTime = () => {
      if (!sessionStartTime) return 60;
      
      const now = new Date();
      const elapsedMs = now.getTime() - sessionStartTime.getTime();
      const elapsedSeconds = Math.floor(elapsedMs / 1000);
      
      // Total rosary duration (sum of all prayer durations)
      const totalRosaryDuration = rosaryData.reduce((sum, prayer) => sum + prayer.duration, 0);
      const amenStartTime = totalRosaryDuration;
      const amenElapsed = elapsedSeconds - amenStartTime;
      
      const remaining = Math.max(0, 60 - amenElapsed);
      return remaining;
    };

    const remaining = calculateRemainingTime();
    setTimeRemaining(remaining);

    if (remaining > 0) {
      const interval = setInterval(() => {
        setTimeRemaining(prev => {
          if (prev <= 1) {
            onComplete();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    } else {
      onComplete();
    }
  }, [sessionStartTime, onComplete]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="amen-container">
      <div className="amen-content">
        <div className="amen-icon">✝️</div>
        
        <h1 className="amen-title">Amen</h1>
        
        <div className="amen-dedication">
          <h2>This Rosary is Dedicated to</h2>
          <h3>World Peace</h3>
        </div>
        
        <div className="amen-prayer">
          <p>
            Lord, we offer this rosary for peace in our world. 
            May the intercession of the Blessed Virgin Mary bring 
            healing, reconciliation, and peace to all nations and peoples. 
            Help us to be instruments of your peace in our daily lives.
          </p>
        </div>
        
        <div className="amen-timer">
          <div className="timer-label">Joining countdown in:</div>
          <div className="timer-display">{formatTime(timeRemaining)}</div>
        </div>
        
        <div className="amen-message">
          <p>Thank you for joining millions around the world in prayer.</p>
          <p>New rosary sessions begin every 30 minutes on the hour and half hour.</p>
          <p>May God bless you and keep you.</p>
        </div>
      </div>
    </div>
  );
};

export default Amen;
